<template>
    <div class="approve container py-4">

        <b-tabs nav-wrapper-class="tab" active-nav-item-class="active-tab" content-class="mt-3 ml-3"
            @activate-tab="changeTab" v-model="currentTabs" pills>
            <b-tab title="TRX" title-item-class="inactive-tab" title-link-class="inactive-link" lazy active>
                <div class="d-flex justify-content-center align-items-center loading-container" v-if="isLoading">
                    <b-spinner variant="success" label="Spinning"></b-spinner>
                </div>

                <div v-else>
                    <div class="d-flex mb-2">
                        <div class="col-lg-6">
                            <button class="btn btn-success" @click="selectAllTransactions('trxTransactions')">Select
                                All</button>
                            <button class="btn btn-danger ml-3"
                                @click="unSelectAllTransactions('trxTransactions')">Unselect
                                All</button>
                        </div>

                        <div class="col-lg-6 d-flex justify-content-end" v-if="trx.selected.length > 1">
                            <button class="btn btn-success" @click="showApproveWithdrawModal">Approve All</button>
                            <button class="btn btn-danger ml-3" @click="showRejectWithdrawModal">Reject All</button>
                        </div>
                    </div>

                    <b-table ref="trxTransactions" :fields="transactionFields" :items="trx.transactions"
                        @row-selected="onTrxRowSelected" select-mode="multi" responsive selectable small show-empty>
                        <!-- th start -->
                        <template v-slot:head(selected)>
                            <div class="table-header-content">
                                <div>Selected</div>
                            </div>
                        </template>

                        <template v-slot:head(request_id)>
                            <div class="table-header-content">
                                <div>Request ID</div>
                            </div>
                        </template>

                        <template v-slot:head(coin)>
                            <div class="table-header-content">
                                <div>Coin</div>
                            </div>
                        </template>

                        <template v-slot:head(amount)>
                            <div class="table-header-content">
                                <div>Amount</div>
                            </div>
                        </template>

                        <template v-slot:head(to_address)>
                            <div class="table-header-content">
                                <div>To Address</div>
                            </div>
                        </template>

                        <template v-slot:head(action)>
                            <div class="table-header-content">
                                <div>Action</div>
                            </div>
                        </template>
                        <!-- th end -->

                        <!-- tbody start -->
                        <template #cell(selected)="{ rowSelected }">
                            <template v-if="rowSelected">
                                <div class="text-center">
                                    <b-form-checkbox :checked="true" size="lg" :disabled="true"></b-form-checkbox>
                                </div>
                            </template>
                            <template v-else>
                                <div class="text-center">
                                    <b-form-checkbox :checked="false" size="lg" :disabled="true"></b-form-checkbox>
                                </div>
                            </template>
                        </template>

                        <template #cell(amount)="row">
                            <div class="text-center">{{ formatNum(row.item.amount, row.item.token.volume_decimal) }}
                            </div>
                        </template>

                        <template #cell(created_at)="row">
                            <div>{{ dateFormatter(row.item.created_at) }}</div>
                        </template>

                        <template #cell(coin)="row">
                            <div class="text-success">{{ row.item.token.api_symbol }}</div>
                        </template>

                        <template #cell(action)="row">
                            <div class="d-flex justify-content-between">
                                <b-icon-check scale="2" class="text-success"
                                    @click.stop.prevent="showApproveWithdrawModal(row, 'trxTransactions', 'single')"></b-icon-check>
                                <b-icon-x scale="2" class="text-danger"
                                    @click.stop.prevent="showRejectWithdrawModal(row, 'trxTransactions', 'single')"></b-icon-x>
                            </div>
                        </template>
                        <!-- tbody end -->
                    </b-table>
                </div>
            </b-tab>

            <b-tab title="BSC" title-item-class="inactive-tab" title-link-class="inactive-link" lazy>
                <div class="d-flex justify-content-center align-items-center loading-container" v-if="isLoading">
                    <b-spinner variant="success" label="Spinning"></b-spinner>
                </div>

                <div v-else>
                    <div class="d-flex mb-2">
                        <div class="col-lg-6">
                            <button class="btn btn-success" @click="selectAllTransactions('bscTransactions')">Select
                                All</button>
                            <button class="btn btn-danger ml-3"
                                @click="unSelectAllTransactions('bscTransactions')">Unselect
                                All</button>
                        </div>

                        <div class="col-lg-6 d-flex justify-content-end" v-if="bsc.selected.length > 1">
                            <button class="btn btn-success" @click="showApproveWithdrawModal">Approve All</button>
                            <button class="btn btn-danger ml-3" @click="showRejectWithdrawModal">Reject All</button>
                        </div>
                    </div>

                    <b-table ref="bscTransactions" :fields="transactionFields" :items="bsc.transactions"
                        @row-selected="onBscRowSelected" select-mode="multi" responsive selectable small show-empty>
                        <!-- th start -->
                        <template v-slot:head(selected)>
                            <div class="table-header-content">
                                <div>Selected</div>
                            </div>
                        </template>

                        <template v-slot:head(request_id)>
                            <div class="table-header-content">
                                <div>Request ID</div>
                            </div>
                        </template>

                        <template v-slot:head(coin)>
                            <div class="table-header-content">
                                <div>Coin</div>
                            </div>
                        </template>

                        <template v-slot:head(amount)>
                            <div class="table-header-content">
                                <div>Amount</div>
                            </div>
                        </template>

                        <template v-slot:head(to_address)>
                            <div class="table-header-content">
                                <div>To Address</div>
                            </div>
                        </template>

                        <template v-slot:head(action)>
                            <div class="table-header-content">
                                <div>Action</div>
                            </div>
                        </template>
                        <!-- th end -->

                        <!-- tbody start -->
                        <template #cell(selected)="{ rowSelected }">
                            <template v-if="rowSelected">
                                <div class="text-center">
                                    <b-form-checkbox :checked="true" size="lg" :disabled="true"></b-form-checkbox>
                                </div>
                            </template>
                            <template v-else>
                                <div class="text-center">
                                    <b-form-checkbox :checked="false" size="lg" :disabled="true"></b-form-checkbox>
                                </div>
                            </template>
                        </template>

                        <template #cell(amount)="row">
                            <div class="text-center">{{ formatNum(row.item.amount, row.item.token.volume_decimal) }}
                            </div>
                        </template>

                        <template #cell(created_at)="row">
                            <div>{{ dateFormatter(row.item.created_at) }}</div>
                        </template>

                        <template #cell(coin)="row">
                            <div class="text-success">{{ row.item.token.api_symbol }}</div>
                        </template>

                        <template #cell(action)="row">
                            <div class="d-flex justify-content-between">
                                <b-icon-check scale="2" class="text-success"
                                    @click.stop.prevent="showApproveWithdrawModal(row, 'bscTransactions', 'single')"></b-icon-check>
                                <b-icon-x scale="2" class="text-danger"
                                    @click.stop.prevent="showRejectWithdrawModal(row, 'bscTransactions', 'single')"></b-icon-x>
                            </div>
                        </template>
                        <!-- tbody end -->
                    </b-table>
                </div>
            </b-tab>

            <b-tab title="ETH" title-item-class="inactive-tab" title-link-class="inactive-link" lazy>
                <div class="d-flex justify-content-center align-items-center loading-container" v-if="isLoading">
                    <b-spinner variant="success" label="Spinning"></b-spinner>
                </div>

                <div v-else>
                    <div class="d-flex mb-2">
                        <div class="col-lg-6">
                            <button class="btn btn-success" @click="selectAllTransactions('ethTransactions')">Select
                                All</button>
                            <button class="btn btn-danger ml-3"
                                @click="unSelectAllTransactions('ethTransactions')">Unselect
                                All</button>
                        </div>

                        <div class="col-lg-6 d-flex justify-content-end" v-if="eth.selected.length > 1">
                            <button class="btn btn-success" @click="showApproveWithdrawModal">Approve All</button>
                            <button class="btn btn-danger ml-3" @click="showRejectWithdrawModal">Reject All</button>
                        </div>
                    </div>

                    <b-table ref="ethTransactions" :fields="transactionFields" :items="eth.transactions"
                        @row-selected="onEthRowSelected" select-mode="multi" responsive selectable small show-empty>
                        <!-- th start -->
                        <template v-slot:head(selected)>
                            <div class="table-header-content">
                                <div>Selected</div>
                            </div>
                        </template>

                        <template v-slot:head(request_id)>
                            <div class="table-header-content">
                                <div>Request ID</div>
                            </div>
                        </template>

                        <template v-slot:head(coin)>
                            <div class="table-header-content">
                                <div>Coin</div>
                            </div>
                        </template>

                        <template v-slot:head(amount)>
                            <div class="table-header-content">
                                <div>Amount</div>
                            </div>
                        </template>

                        <template v-slot:head(to_address)>
                            <div class="table-header-content">
                                <div>To Address</div>
                            </div>
                        </template>

                        <template v-slot:head(action)>
                            <div class="table-header-content">
                                <div>Action</div>
                            </div>
                        </template>
                        <!-- th end -->

                        <!-- tbody start -->
                        <template #cell(selected)="{ rowSelected }">
                            <template v-if="rowSelected">
                                <div class="text-center">
                                    <b-form-checkbox :checked="true" size="lg" :disabled="true"></b-form-checkbox>
                                </div>
                            </template>
                            <template v-else>
                                <div class="text-center">
                                    <b-form-checkbox :checked="false" size="lg" :disabled="true"></b-form-checkbox>
                                </div>
                            </template>
                        </template>

                        <template #cell(amount)="row">
                            <div class="text-center">{{ formatNum(row.item.amount, row.item.token.volume_decimal) }}
                            </div>
                        </template>

                        <template #cell(created_at)="row">
                            <div>{{ dateFormatter(row.item.created_at) }}</div>
                        </template>

                        <template #cell(coin)="row">
                            <div class="text-success">{{ row.item.token.api_symbol }}</div>
                        </template>

                        <template #cell(action)="row">
                            <div class="d-flex justify-content-between">
                                <b-icon-check scale="2" class="text-success"
                                    @click.stop.prevent="showApproveWithdrawModal(row, 'ethTransactions', 'single')"></b-icon-check>
                                <b-icon-x scale="2" class="text-danger"
                                    @click.stop.prevent="showRejectWithdrawModal(row, 'ethTransactions', 'single')"></b-icon-x>
                            </div>
                        </template>
                        <!-- tbody end -->
                    </b-table>
                </div>
            </b-tab>
        </b-tabs>

        <!-- Approve Withdraw -->
        <b-modal ref="approve-withdraw-modal" hide-footer title="APPROVE WITHDRAW" centered>
            <form class="modal-form" @submit.stop.prevent="approveWithdraw('approve-withdraw-modal')">
                <div class="d-flex flex-column align-items-center justify-content-center">
                    <p>Please key in 2FA code to continue the action</p>
                    <v-otp-input ref="otpInput" input-classes="otp-input" separator="" :num-inputs="6"
                        :should-auto-focus="true" :is-input-num="true" v-model="twoFaCode" input-type="number"
                        @on-complete="onTwoFaComplete" />
                    <button class="mt-5 activate-btn">Confirm</button>
                </div>
            </form>
        </b-modal>

        <!-- Reject Withdraw -->
        <b-modal ref="reject-withdraw-modal" hide-footer title="REJECT WITHDRAW" centered>
            <form class="modal-form" @submit.stop.prevent="rejectWithdraw('reject-withdraw-modal')">
                <div class="d-flex flex-column align-items-center justify-content-center">
                    <p>Please key in 2FA code to continue the action</p>
                    <v-otp-input ref="otpInput" input-classes="otp-input" separator="" :num-inputs="6"
                        :should-auto-focus="true" :is-input-num="true" v-model="twoFaCode" input-type="number"
                        @on-complete="onTwoFaComplete" />
                    <button class="mt-5 activate-btn">Confirm</button>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
import api from '../helper/api.js';
import moment from 'moment';
import coinHelper from "../helper/coin.js";
import Swal from 'sweetalert2';

export default {
    name: "Approve",
    data() {
        return {
            transactionFields: [
                { key: "selected", label: "Selected" },
                { key: "created_at", label: "Created at" },
                { key: "request_id", label: "Request ID" },
                { key: "coin", label: "Coin" },
                { key: "amount", label: "Amount" },
                { key: "to", label: "To Address" },
                { key: "action", label: "Action" }
            ],
            isLoading: true,
            // bscTransactions: [],
            // trxTransactions: [],
            // ethTransactions: [],

            // bscSelected: [],
            // trxSelected: [],
            // ethSelected: [],

            trx: {
                transactions: [],
                selected: [],
                isUpdate: false,
            },

            bsc: {
                transactions: [],
                selected: [],
                isUpdate: false,
            },

            eth: {
                transactions: [],
                selected: [],
                isUpdate: false,
            },

            twoFaCode: "",
            currentTabs: 0,
            networks: ['trx', 'bsc', 'eth']
        }
    },
    async mounted() {
        await this.fetchPendingTransactions(0);
        this.isLoading = false;
        this.currentTabs = localStorage.getItem('currentApproveTab');
    },
    methods: {
        async fetchPendingTransactions(index) {

            let currentNetwork = this.networks[index];

            if (this[currentNetwork].isUpdate) {
                return;
            }

            let params = {
                status: 'pending_approve'
            };

            const response = await api.apiCall(this.networks[index], 'GET', '/withdrawals', params);
            this[currentNetwork].transactions = response.message.data;
            this[currentNetwork].isUpdate = true
        },

        showApproveWithdrawModal(row = '', ref = '', type = "multi") {


            if (type == 'single') {
                this.$refs[ref].clearSelected();

                this.$nextTick(() => {
                    let network = this.networks[this.currentTabs];
                    this[network].selected = [row.item];
                });
            }


            this.$refs['approve-withdraw-modal'].show();
        },

        showRejectWithdrawModal(row = '', ref = '', type = 'multi') {


            if (type == 'single') {
                this.$refs[ref].clearSelected();

                this.$nextTick(() => {
                    let network = this.networks[this.currentTabs];
                    this[network].selected = [row.item];
                });
            }

            this.$refs['reject-withdraw-modal'].show();
        },

        async approveWithdraw(ref) {

            if (!this.twoFaCode || this.twoFaCode == "") {
                Swal.fire({
                    text: "Please fill in 2FA",
                    icon: 'error',
                });
            }
            let network = this.networks[this.currentTabs];

            let withdraw_id = this[network].selected.map(item => item.id);

            let params = {
                withdrawal_id: withdraw_id,
                action: "approve",
                google2fa: this.twoFaCode
            };

            try {
                await api.apiCall(network, 'POST', '/withdrawals/approve', params);

                Swal.fire({
                    text: "Approve success",
                    icon: 'success',
                });

                this[network].isUpdate = false;
                this.fetchPendingTransactions(this.currentTabs);
                this.$refs[ref].hide();

            } catch (error) {
                Swal.fire({
                    text: error.message,
                    icon: 'error',
                })
                this.twoFaCode = '';
            }

        },

        async rejectWithdraw(ref) {

            if (!this.twoFaCode || this.twoFaCode == "") {
                Swal.fire({
                    text: "Please fill in 2FA",
                    icon: 'error',
                })
            }

            let network = this.networks[this.currentTabs];

            let withdraw_id = this[network].selected.map(item => item.id);

            let params = {
                withdrawal_id: withdraw_id,
                action: "reject",
                google2fa: this.twoFaCode
            };

            try {
                await api.apiCall(network, 'POST', '/withdrawals/approve', params);

                Swal.fire({
                    text: "Reject success",
                    icon: 'success',
                });

                this[network].isUpdate = false;
                this.fetchPendingTransactions(this.currentTabs);
                this.$refs[ref].hide();

            } catch (error) {
                Swal.fire({
                    text: error.message,
                    icon: 'error',
                })
                this.twoFaCode = '';
            }
        },

        onTwoFaComplete(value) {
            this.twoFaCode = value;
        },

        onBscRowSelected(items) {
            this.bsc.selected = items;
        },

        onTrxRowSelected(items) {
            this.trx.selected = items;
        },

        onEthRowSelected(items) {
            this.eth.selected = items;
        },

        changeTab(currentTabs) {
            console.log(currentTabs);
            this.fetchPendingTransactions(currentTabs);
            localStorage.setItem('currentApproveTab',currentTabs);
        },

        selectAllTransactions(networkTransactions) {
            // this.$refs.bscTransactions.selectAllRows();
            this.$refs[networkTransactions].selectAllRows();
        },

        unSelectAllTransactions(networkTransactions) {
            this.$refs[networkTransactions].clearSelected();
        },

        dateFormatter(value) {
            if (value) {
                return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
            }
        },

        formatNum(num, decimal) {
            return coinHelper.formatNumberWithCommas(num, decimal);
        },
    },
}
</script>

<style>
@import '../css/styles.css';

.approve .loading-container {
    min-height: 500px;
}

.approve .active-tab {
    background-color: var(--primary-10) !important;
    color: var(--primary) !important;
    border-radius: 20px;
}

.approve .inactive-tab {
    border: 1px solid var(--primary);
    margin-left: 20px;
    border-radius: 20px;
}

.approve .inactive-link {
    color: var(--primary);
}

.approve table th {
    text-align: center;
}

.approve table td {
    vertical-align: baseline;
}
</style>